import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
// In this snippet, we define a ScrollToTop component that uses the useLocation hook from react-router-dom to access the current location. We then use the useEffect hook to scroll the window to the top whenever the pathname changes. This ensures that the page is scrolled to the top whenever a new route is navigated to. The component returns null since it doesn't render any UI elements.